import {Service} from './request';
import config from '../core/config/config';

// 创建API工厂函数
const api = (method) => (url) => (param) => Service[method](url, param);
const post = api('post');
const get = api('get');

export default {

    // ============ access ============
    settleCenter: post('/access/branch/access/list'), // 集团公司&总公司理财充值审核列表
    getBranchRechargeList: post('/access/branch/access/list/company'), // 获取分公司公司理财充值列表
    settleInfo: post('/access/details'), // 分公司结算中心查看详情
    settleDfInfo: post('/access/bossLook/details'), // 分公司代付上分查看详情
    getFindMecAccessData: post('/access/findMecAccessData'), // 总公司查商户和代理结算中心，商户、商代、分代提现管理
    postAccessXf: post('/access/qs/xf'), // 提现申请 --wtg
    mer_detailAccess: post('/access/findDealListById'), // 商户上下分详情 --wtg
    mer_submitRequest: post('/access/updateAccessInfo'), // 商户上下分审批 ——wtg
    remittanceList: post('/access/remittance/list'), // 管理端汇款中心
    detailAccess: post('/access/details'), // 汇款详情
    shDfSave: post('/access/vip/remittance'), // 商户代付下分申请
    floatingDetail: post('/access/floating/detail'), // 充值审批记录浮框
    com_submitRequest: post('/access/success'), // 分公司上下分审批通过
    com_submitRejected: post('/access/rejected'), // 分公司上下分审批拒绝
    getQsPayInfo: post('/access/qs/loadPay'), // 分公司上分加载银行资料
    postSaveSf: post('/access/vip/sf'), // 分公司上分申请 --wtg
    accessDetail: post('/access/detail/number'), // 分公司结算管理中的抢单充值浮框
    getCompanyInfo: post('/access/rob'), // 分公司代付查看详情
    componyDfSuccess: post('/access/chooseRob'), // 分公司代付抢单成功
    componyDfPass: post('/access/endRob'), // 分公司放弃抢单
    DfPayBtn: post('/access/remittance/success'), // 商户汇款确认收款
    DLTXDot: post('/access/query/countmessage'), // 获取未处理红点数量
    DLTXHEADDot: post('/access/query/countmessage'), // 代理提现-总公司提现红点提示
    DIGITDot: post('/access/digit/query/countmessage'), // 数字货币红点
    getMerComWithdrawalList: post('/access/findMecAccessDataOther'), // 获取商户、商代、总公司提现管理/提现列表
    subDigital: post('/access/digit/save/digit'), // 保存数字货币充值记录
    getMerDigitalList: post('/access/digit/get/digit'),
    merDigitalInfo: post('/access/digit/get/digit/id'), // 查询充值记录接口
    digitalPass: post('/access/digit/digit/status'), // 数字货币充值审批
    getLuckyFinanceList: post('/access/select/remittance'), // 获取幸运理财列表

    // ============ add ============
    addEmployee: post('/add/employee'),

    // ============ addMecUser ============
    addMecUser: post('/addMecUser'), // 商户管理添加商户用户 --wtg

    // ============ admin ============
    login: post('/admin/login'),
    postUserList: post('/admin/lower/list'), // 获取分公司列表 --hb
    getMemberList: post('/admin/member/list'), // 获取会员列表
    getUserInfo: post('/admin/update/detail'), // 获取会员用户信息 --hb

    // ============ advertising ============
    saveAd: post('/advertising/add/single'), // 添加广告
    getAdList: post('/advertising/mgr/list'), // 获取广告列表
    changeAdvertisingStatus: post('/advertising/updateStatus'), // 获取广告列表
    delectAd: post('/advertising/delete/single'), // 删除广告
    updateAd: post('/advertising/update/single'), // 修改广告

    // ============ agency ============
    getAgentList: post('/agency/list'), // 商户代理 获取代理信息 --wtg
    getAgencyProfit: post('/agency/statement'), // 代理利润报表
    getAgencyTran: post('/agency/deal'),

    // ============ all ============
    getAllAnchors: post('/all/anchor'), // 获取所有主播列表
    getAllAnchorCompany: post('/all/anchor/company'), // 获取所有主播公司

    // ============ anchor ============
    editAnchor: post('/anchor/edit/user'), // 修改直播公司/主播通道状态
    getAnchorsInfo: post('/anchor/detail/by/id'), // 查看要修改的主播/主播公司详情
    getRecommendList: post('/anchor/managetment/list'), // 主播推荐管理
    recommendInfo: post('/anchor/managetment/detail'), // 主播详情
    changeFansNum: post('/anchor/managetment/top'), // 主播粉丝数/置顶修改

    // ============ area ============
    queryAreaById: post('/area/queryById'), // 查询所有洲
    queryContinent: post('/area/continent'), // 查询所有洲
    queryCountry: post('/area/country'), // 查询所有国家
    queryState: post('/area/state'), // 查询所有省份
    searchCities: post('/area/city'), // 查询所有市级
    changeRegionStatus: post('/area/changeStatus'),
    getContinent: post('/area/continent'), // 查询所有洲
    getCountry: post('/area/country'), // 查询国家
    getStates: post('/area/state'), // 查询省份
    getCity: post('/area/city'), // 查询城市

    // ============ balance ============
    userUnusualReport: post('/balance/subsidiary/margin'), // 会员资金异常表
    companyMoneyReport: post('/balance/subsidiary/detail'), // 分公司资金报表
    companyMoneyFloat: post('/balance/subsidiary/float/show'), // 分公司资金报表浮窗
    getMerFunds: post('/balance/subsidiary/detail'), // 获取商户资金报表
    getMerFundsTip: post('/balance/subsidiary/merchant/float/show'), // 获取商户资金报表浮窗f

    // ============ bank ============
    getBankSystemList: post('/bank/info/bankInfolist'), // 查找银行信息 ——wtg
    putBankSystem: post('/bank/info/update/single'), // 修改银行信息 ——wtg
    getbankInfoById: post('/bank/info/bankInfo/id '), // 获取修改银行信息详情 ——wtg
    postBankSystem: post('/bank/info/add/single'), // 新增银行信息 ——wtg
    openOrDelBank: post('/bank/info/updateBankStatus'), // 银行卡开启关闭/删除
    getBankOfCurrency: post('/bank/info/selectBankByCurrise'), // 根据货币获取银行
    getBankCardInfo: post('/bank/pay/bank/info'), // 分公司本币理财外币理财加载银行卡资料
    getBankAdminList: post('/bank/bossBankCar'), // 银行卡管理获取所有银行卡
    getbankCardInfoById: post('/bank/bank/detail'), // 获取修改银行卡信息详情 ——wtg
    BankCardCtrl: post('/bank/update/banklimit'), // 银行卡管理流量控制开关
    delComBankCards: post('/bank/delect/company/userBank'), // 总公司，分公司删除银行卡
    getMerPayInfo: post('/bank/bank/info'), // 商户端：获取商户支付信息
    loadDigitalCard: post('/bank/bank/info/digit'), // 加载数字货币银行卡

    // ============ bonus ============
    getAgentCurrencyTip: post('/bonus/profit/total/currency'), // 浮窗代理列表根据用户id查盈利多币别 --wtg
    findUserBonus: post('/bonus/admin/userbonus'), // 提现提成查询
    eachBonus: post('/bonus/each/bonus'), // 浮窗显示各个等级的提成总额
    bonusDetail: post('/bonus/detail'), // 会员提成详细信息
    getGiftFree: post('/bonus/getGiftFree'), // 获取消费记录提成
    getProfit: post('/bonus/total/profit'), // 获取总公司/分公司利润报表

    // ============ change ============
    getCurrencyList: post('/change/currency/user/currency'), // 修改会员/分公司资料获取开启货币
    delCurrency: post('/change/currency/delete/single'), // 删除用户持有币别
    addCurrency: post('/change/currency/add/single'), // 添加用户持有币别
    getMerCurrencyTip: post('/change/currency/query/amountnotmain'), // 浮窗商户列表和代理列表根据用户id看多币别，昵称 --wtg
    getAccountBanlance: post('/change/currency/query/amount'), // 获取商户列表商户余额弹窗数据
    getCurrencyQueryAmount: post('/change/currency/query/amount'), // 查询所有货币 --wtg
    getUserCurrency: post('/change/currency/query/amount'), // 获取货币
    changeCurrencyExchange: post('/change/currency/exchange/amount'), // 获取货币
    chooseCurrency: post('/change/currency/currency/company'), // 加载币别

    // ============ channel ============
    getUserPayInfo: post('/channel'), // 查看通道列表
    getScanPayType: post('/channel/type/by/lang'), // 新建银行卡获取扫码类型
    getAllChannel: post('/channel/type/allPaymode'), // 获取所有通道【集团创建总公司、商代】
    getUserSelectChannel: post('/channel/type/by/userId'), // 显示用户有那些通道，传用户id
    getAllChannelPage: post('/channel/type/query/page'),
    addNewChannel: post('/channel/type/add/single'),
    editChannel: post('/channel/type/update/single'),
    editChannelStatus: post('/channel/type/updateStatus'),
    searchPayType: post('/channel/type/byuser/langisopen'), // 查找支付类型
    getVeChannels: post('/channel/type/currency/list'), // 查询ve所有通道
    editVeChannelStatus: post('/channel/type/currency/open/status'), // 修改ve通道状态
    getVeChannelCurrency: post('/channel/type/currency/list/by/id'), // 查看ve通道对应的币别
    openVeChannelCurrency: post('/channel/type/currency/add'), // 开启/关闭通道支持币别
    getTopInfo: post('/channel/type/channel/type/addMer'), // 查看上级费率

    // ============ club ============
    searchClub: post('/club/all'), // 查找会所
    updateClub: post('/club/update/single'), // 修改删除会所

    // ============ commission ============
    getSelectCommissionList: post('/commission/selectCommissionList'), // 总公司.商户  入金手续费查询
    getAnchorPayCommissionList: post('/commission/selectAnchorCommissionList'), // 获取主播充值手续费列表

    // ============ community ============
    saveCommunity: post('/community/add'),
    updateCommunity: post('/community/edit'),
    deleteCommunity: post('/community/delete'),
    updateStatusCommunity: post('/community/updateStatus'),
    queryDataListCommunity: post('/community/queryList'),
    saveCommunityLink: post('/community/link/add'),
    updateCommunityLink: post('/community/link/edit'),
    deleteCommunityLink: post('/community/link/delete/single'),
    updateStatusCommunityLink: post('/community/link/updateStatus'),
    queryDataListCommunityLink: post('/community/link/query/page'),

    // ============ contactInformation ============
    cooperationList: post('/contactInformation/list'), // 意向合作伙伴列表
    cooperationInfo: post('/contactInformation/detail'), // 意向合作伙伴详情

    // ============ country ============
    getAreaCode: post('/country/prefix/query/enable'), // 登录页--获取地区号
    getArea: post('/country/countryList'), // 获取地区
    getCountryList: post('/country/countryList'), // 获取添加新银行国家

    // ============ credit ============
    getCreditLimt: post('/credit/limit/limit/list'), // 获取提额信息
    raiseInfo: post('/credit/limit/limit/detail'), // 提额详情浮窗
    raiseSub: post('/credit/limit/apply/limit'), // 管理端审批提额申请
    limitList: post('/credit/limit/merchant/limit/list'), // 商户提额列表
    merchantRaise: post('/credit/limit/increase/limit'), // 商户申请提额
    getMerFlowInfos: post('/credit/limit/flow/list'), // 商户端：获取商户流量信息
    getMerFlowPurchaseInfos: post('/credit/limit/purchase/list'), // 获取商户流量购买详情
    merchantByDot: post('/credit/limit/query/countmessage'), // 商户购入流量审批数量/会员提额审批数量
    HEADLLDot: post('/credit/limit/query/countmessage'), // 总公司购入流量审批红点提示
    FLOWDot: post('/credit/limit/query/countmessage'), // 集团分公司流量审核红点提示
    comAtList: post('/credit/limit/company/limit/list'), // 总公司流量购入列表
    getCompanyFlowList: post('/credit/limit/company/limit/list/boss'), // 集团公司获取总公司流量购入审核列表
    getMerchantFlowList: post('/credit/limit/merchant/limit/list/boss'), // 集团公司获取商户流量购入审批列表
    getBranchFlowBought: post('/credit/limit/fcompany/limit/list'), // 获取分公司流量购入信息列表
    getBranchFlowList: post('/credit/limit/fcompany/limit/list/boss'), // 集团获取分公司流量列表
    getAnchorCompanyFlow: post('/credit/limit/anchorCompany/limit/list/boss'), // 集团审批直播公司流量购入列表
    checkAnchorsFlowApproval: post('/credit/limit/live/anchor/limit/list'), // 集团和直播公司查看主播流量申请
    getAnchorsFlow: post('/credit/limit/anchorCompany/limit/list'), // 直播公司查看自身流量购入
    getMerchantAgentFlowList: post('/credit/limit/merchant/agent/limit/list/boss'), // 获取商代流量购入列表

    // ============ currency ============
    getAllCurrency: post('/currency/findAllCurrency'), // 查询所有货币 --wtg
    updateCurrencyStatus: post('/currency/updateStatus'),
    updateCurrencyIsHot: post('/currency/updateIsHot'),
    updateCurrencyIsMain: post('/currency/updateIsMain'),
    updateCurrencyIsCommon: post('/currency/updateIsCommon'),
    updateDigitCurrencyIsCommon: post('/digit/currency/updateIsCommon'),
    getCurrencies: post('/currency/allCurrencies'), // 查询所有货币信息 ——wtg
    getCanSelecteCurrency: post('/currency/allCurrenciesBypower'), // 获取当前可选择货币
    getCurrencyRate: post('/currency/curr/rate'), // 查询所有货币 --wtg
    getUserRate: post('/currency/to/currency/rate'), // 分公司获取汇率
    handCurrency: post('/currency/manual/pay/order'), // 手动派单货币类型
    postCurrencies: post('/currency/add/single'), // 增加货币 --wtg
    replaceCurrencies: post('/currency/update/single'), // 修改货币
    deleteCurrencies: post('/currency/currency/delflag'), // 删除货币 --wtg
    getCountryToRate: post('/currency/each/rate'), // 查询各个货币换算汇率
    queryEnableCurrencies: post('/currency/query/enable'),
    findAllCurrency: post('/currency/findAllCurrency/page '), // 查询各个货币换算汇率
    changeCountryRate: post('/currency/save/update/rate'), // 修改各个国家货币汇率
    getCurrencyDetail: post('/currency/by/id'), // 根据id获取货币列表 修改详情
    getCurrencyExchange: post('/currency/exchange'), // 法定货币兑换手续费率，兑得钱，手续费，汇率
    getChangeAmount: post('/currency/curr/amount'), // 根据币别查询对应的金额
    getNewCurrency: post('/currency/findMainCurrency'), // 添加分公司/商户获取主货币
    getBranchFlowCurrency: post('/currency/findMainCurrency'), // 获取分公司新增流量购入的支持货币
    getBranchFlowCurrencyRate: post('/currency/get/curr/rate'), // 获取分公司新增流量购入的支持货币的汇率

    // ============ del ============
    delAnchorCompany: post('/del/anchor/company'), // 删除主播公司

    // ============ delegate ============
    searchCurrencyStatus: post('/delegate/change/detail/id'), // 查询兑换货币状态
    changeCurrencyStatus: post('/delegate/change/switch'), // 兑换货币开关
    changeAreaStatus: post('/delegate/change/third/type'), // 兑换洲开关
    addClub: post('/delegate/change/third/type'), // 添加会所
    newDigital: post('/delegate/change/third/type'), // 添加数字货币
    getChangeList: post('/delegate/change/list'), // 根据委托类型和洲和国家id查询对应兑换内容

    // ============ deleteFlag ============
    deleting: post('/deleteFlag/user'), // 删除角色

    // ============ digit ============
    getDigitCurrencyDetail: post('/digit/currency/by/id'), // 根据id获取数字货币列表 修改详情
    addDigital: post('/digit/currency/add/single'), // 添加数字货币
    updateDigital1: post('/digit/currency/update/single'), // 修改数字货币
    setDigi: post('/digit/currency/update/status'), // 数字货币设置
    updateOtcUsageStatus: post('/digit/currency/updateOtcUsageStatus'),
    searchDigital: post('/digit/currency/query/all'), // 查询所有数字货币
    getDigitalList: post('/digit/currency/by/all'), // 获取数字货币列表
    changeDigital: post('/digit/currency/rate/get/rate'), // 数字货币转法币
    changeDC: post('/digit/currency/rate/get/cuctodigrate'), // 法币转数字货币
    searchDigitalRate: post('/digit/currency/select/rate'), // 查询数字货币兑换美元双向汇率
    digitalRateChange: post('/digit/currency/update/rate'), // 修改数字货币对法币的汇率

    // ============ edit ============
    putUserInfo: post('/edit/user'), // 商户管理修改商户用户  --wtg
    editEmployee: post('/edit/employee'), // 修改员工资料  --wtg
    editAnchorStatu: post('/edit/anchor'), // 修改主播状态

    // ============ equivalent ============
    updateDispatch: post('/equivalent/usd/update'), // 修改派单阈值

    // ============ exchange ============
    getFindAllExchange: post('/exchange/find/all/exchange'), // 商户、分公司、总公司,代理查询兑换记录 --wtg
    exchangeQueryList: post('/exchange/queryList'),
    exchangeQueryStatisticsInfo: post('/exchange/query/statistics/info'),
    getExchangetDetails: post('/exchange/query/id'), // 查询法定和委托兑换记录详情 --wtg
    postAddExchange: post('/exchange/add/single'), // 添加兑换订单
    getUserShenPi: post('/exchange/check'), // 汇款兑换审批
    DHSPDot: post('/exchange/query/countmessage'), // 兑换待审批数量

    // ============ exclusive ============
    addMemberUser: post('/exclusive/member/add/single'), // 添加专属会员
    delMemberUser: post('/exclusive/member/delete/single'), // 删除专属会员
    postMerchantTip: post('/exclusive/member'), // 查询专属服务
    putUserPass: post('/exclusive/member/update/exclusive/channel'),
    getMerServerTip: post('/exclusive/member/query/exclusive/channel'), // 浮窗商户列表专属会员 --wtg

    // ============ fail ============
    getMatchFailedList: post('/fail/pay/order/findList'), // 获取匹配失败列表

    // ============ fault ============
    faultlist: post('/fault/faultList'), // 入金故障单查询全部  --wtg
    findFault: post('fault/find/vip/fault'), // 查询会员故障单
    faultInfo: post('/fault/faultDetail'), // 查看故障单详情
    updateFaultStuts: post('/fault/updateFaultOrderStatus'), // 处理故障单
    postFaultRe: post('/fault/reHandle'), // 重审故障单
    putToFault: post('/fault/add/single'), // 提交新增故障单
    merchantFaultDot: post('/fault/query/countmessage'), // 商户入金故障单待处理数量/会员提现中心-提现故障单待处理数量
    getAnchorPayFaultList: post('/fault/find/anchor/fault'), // 获取主播充值故障单

    // ============ finance ============
    getFinanceProducts: post('/finance/products/manager/detail'), // 理财产品
    getCompanyList: post('/finance/product/company/info'), // 获取公司列表
    postAddProducts: post('/finance/products/add/single'), // 新增理财产品
    delProducts: post('/finance/products/delete/single'), // 删除理财产品
    editAddProducts: post('/finance/products/update/single'), // 修改理财产品
    getCompanyDetailTip: post('/finance/products/company/detail'), // 理财产品浮窗显示分公司创建 --wtg
    getProductsDetailTip: post('/finance/products/detail'), // 浮窗显示理财产品详情 ——wtg

    // ============ financial ============
    getMerBalanceTip: post('/financial/records/manage/total/currency'), // 浮窗商户列表理财多币别 --wtg
    getFinancialRecords: post('/financial/records/buy/financial/records'), // 理财购买申请 理财购买记录 --wtg
    submitFinanceApproval: post('/financial/records/approval/financial'), // 理财产品审批 --wtg
    postPayOut: post('/financial/records/sale/financial'), // 商户理财产品报表 卖出理财--wtg
    PTLCDot: post('/financial/records/query/countmessage'), // 商户入金故障单待处理数量/会员提现中心-提现故障单待处理数量
    getAcccerroeList: post('/financial/records/system/acccerroeList'), // 获取汇款错误处理列表
    goToComplete: post('/financial/records/system/luckComplete'), // 错误汇款转完成

    // ============ findAllMemberNameAndNickNameAndLike ============
    findMemberlist: post('/findAllMemberNameAndNickNameAndLike'), // 查找符合会员

    // ============ findExclusiveMember ============
    checkMemberlist: post('/findExclusiveMember'), // 获取指定专属会员详情

    // ============ findExclusiveMemberList ============
    memberlist: post('/findExclusiveMemberList'), // 获取专属会员列表

    // ============ freeze ============
    freezeList: post('/freeze/all/list'), // 冻结资金列表
    freezeDetail: post('/freeze/order/detail'), // 冻结资金浮窗查看详情
    freezeSuccess: post('/freeze/apply/operation'), // 总公司冻结审批
    freezeInOk: post('/freeze/update/freeze/status'), // 申请解冻
    merchantFreeze: post('/freeze/query/countmessage'), // 商户入金冻结待审批待处理数量
    getAnchorFreeze: post('/freeze/all/anchor/list'), // 主播冻结资金查询

    // ============ get ============
    postUserTip: post('/get/detail/by/name'), // 根据会员名显示会员基本信息
    postParentTip: post('/get/parent/by/level'), // 根据用户类型显示上级名称
    postBalanceTip: post('/get/detail/by/balance'), // 根据余额查出各个货币余额
    postLowerTip: post('/get/detail/by/lower'), // 找出详细直属下线

    // ============ getAgencyInfoById ============
    getNewDai: post('/getAgencyInfoById/'), // 代理新增商户获取率
    addNewCompany: post('/getAgencyInfoById'), // 分代新增分公司获取代理费率

    // ============ getAnchorCompnayInfoById ============
    getAnchorCompanyRate: post('/getAnchorCompnayInfoById'), // 获取直播公司自己的其他费率

    // ============ getBusinessApprovalList ============
    getApplyList: post('/getBusinessApprovalList'), // 集团公司-业务审批中心获取列表

    // ============ getBusinessApprovalListByAgency ============
    getMerBranchApplyList: post('/getBusinessApprovalListByAgency'), // 商代/总公司-业务审批中心获取列表

    // ============ gift ============
    getAllLiveGift: post('/gift/get/list/gift'),
    addNewGift: post('/gift/save/gift'),
    getGiftInfo: post('/gift/get/gift'),
    eidtGift: post('/gift/update/gift'),
    editGiftStatus: post('/gift/update/gift/status'),
    deleteGift: post('/gift/del/gift'),

    // ============ influencer ============
    queryInfluencerApplyList: post('/influencer/apply/queryList'), // 查询申请列表
    approveInfluencerApply: post('/influencer/apply/approve'), // 审批申请
    unbanInfluencerApply: post('/influencer/apply/unban'), // 解封申请
    getInfluencerApplyDetail: post('/influencer/apply/detail'), // 获取申请详情
    deleteInfluencerApply: post('/influencer/apply/delete'), // 删除申请记录
    getMyInfluencerApplyStatus: post('/influencer/apply/myStatus'), // 获取当前用户申请状态
    getInfluencerApplyLogs: post('/influencer/apply/logs'),
    getInfluencerApplyLogsByUser: post('/influencer/apply/log/queryByUserId'), // 查询用户申请记录
    getInfluencerApplyLogStatistics: post('/influencer/apply/log/statistics'), // 获取申请记录统计
    updateInfluencerStatus: post('/influencer/status/update'), // 设置用户达人状态
    banInfluencer: post('/influencer/ban'), // 封禁达人
    muteInfluencer: post('/influencer/mute'), // 禁言达人
    restoreInfluencer: post('/influencer/restore'), // 恢复达人正常状态
    revokeInfluencer: post('/influencer/revoke'), // 取消达人资格
    batchUpdateInfluencerStatus: post('/influencer/batch/status/update'), // 批量操作达人状态
    getInfluencerStatistics: post('/influencer/statistics'), // 获取达人统计信息
    getInfluencerDetail: post('/influencer/detail'), // 获取达人详情
    getAvailableTasks: post('/influencer/task/available/list'), // 获取可领取任务列表（达人端）
    getTaskDetail: post('/influencer/task/detail'), // 获取任务详情
    createTask: post('/influencer/task/create'), // 创建任务（管理员）
    getTaskList: post('/influencer/task/admin/list'), // 管理员查询任务列表
    publishTask: post('/influencer/task/publish'), // 发布任务
    cancelTask: post('/influencer/task/cancel'), // 取消任务
    getTaskStatistics: post('/influencer/task/statistics'), // 获取任务统计信息
    claimTask: post('/influencer/task/claim/claim'), // 领取任务
    submitTask: post('/influencer/task/claim/submit'), // 提交任务
    cancelTaskClaim: post('/influencer/task/claim/cancel'), // 取消任务接取
    getMyTaskClaims: post('/influencer/task/claim/my/list'), // 查询用户的任务接取记录
    getAllTaskClaims: post('/influencer/task/claim/admin/list'), // 管理员查询所有接取记录
    getClaimDetail: post('/influencer/task/claim/detail'), // 获取任务接取详情
    reviewTaskSubmission: post('/influencer/task/claim/review'), // 审核任务提交
    getClaimStatistics: post('/influencer/task/claim/statistics'), // 获取接取统计信息
    getPendingReviews: post('/influencer/task/claim/pending/reviews'), // 查询待审核的提交记录
    processExpiredTasks: post('/influencer/task/claim/process/expired'), // 批量处理过期任务
    getTaskDataByClaimId: post('/influencer/task/data/list'), // 根据接取记录ID查询任务数据
    submitTaskData: post('/influencer/task/data/submit'), // 提交任务完成数据
    verifyTaskData: post('/influencer/task/data/verify'), // 验证任务数据
    getTaskDataStatistics: post('/influencer/task/data/statistics'), // 获取任务数据统计
    getUnverifiedData: post('/influencer/task/data/unverified/list'), // 查询待验证的数据记录
    batchVerifyData: post('/influencer/task/data/batch/verify'), // 批量验证数据
    getTaskRewards: post('/influencer/task/reward/list'), // 根据任务ID查询奖励梯度列表
    saveTaskRewards: post('/influencer/task/reward/save'), // 保存任务奖励梯度配置（批量）
    addTaskReward: post('/influencer/task/reward/add'), // 添加单个奖励梯度
    updateTaskReward: post('/influencer/task/reward/update'), // 更新奖励梯度
    deleteTaskReward: post('/influencer/task/reward/delete'), // 删除奖励梯度
    getRewardLogs: post('/influencer/reward/logs'), // 查询奖励发放记录
    manualReward: post('/influencer/reward/manual'), // 手动发放奖励
    retryFailedReward: post('/influencer/reward/retry'), // 重新发放失败的奖励
    getRewardStatistics: post('/influencer/reward/statistics'), // 获取奖励统计信息
    getInfluencerStats: post('/influencer/stats/list'), // 查询达人统计信息列表
    getInfluencerStatsDetail: post('/influencer/stats/detail'), // 获取达人统计详情
    updateInfluencerStats: post('/influencer/stats/update'), // 更新达人统计信息
    getInfluencerRanking: post('/influencer/stats/ranking'), // 获取达人排行榜
    updateTask: post('/influencer/task/update'), // 更新任务
    toggleTaskTop: post('/influencer/task/toggle-top'), // 置顶/取消置顶任务
    moveTask: post('/influencer/task/move'), // 上移/下移任务(手动排序)

    // ==================== 以下内容添加到 backend-api.js 的 export default 对象中 ====================
    createUserQRCode: post('/user/qrcode/admin/generate-marketing'), // 生成营销推广码
    // ============ marketer application (营销精英申请管理) ============
    getMarketerApplicationList: post('/marketer/application/admin/list'), // 查询营销精英申请列表
    getMarketerApplicationDetail: post('/marketer/application/admin/detail'), // 获取申请详情
    reviewMarketerApplication: post('/marketer/application/admin/review'), // 审核申请
    getMarketerApplicationStatistics: post('/marketer/application/admin/statistics'), // 获取申请统计数据
    validateReferralCode: post('/marketer/application/validate/referral-code'), // 验证推荐码是否有效

    // ============ marketer info (营销精英管理) ============
    getMarketerList: post('/marketer/info/admin/list'), // 分页查询营销精英列表
    getMarketerDetail: post('/marketer/info/admin/detail'), // 获取营销精英详情
    createMarketer: post('/marketer/info/admin/create'), // 后台直接新增营销精英
    updateMarketer: post('/marketer/info/admin/update'), // 修改营销精英信息
    updateMarketerStatus: post('/marketer/info/admin/update-status'), // 修改营销精英状态
    setMarketerReferPermission: post('/marketer/info/admin/set-refer-permission'), // 设置推荐权限
    getMarketerStatistics: post('/marketer/info/admin/statistics'), // 获取营销精英统计数据
    getMarketerReferralTree: post('/marketer/info/admin/referral-tree'), // 查询推荐关系树
    resetMarketerCode: post('/marketer/info/admin/reset-code'), // 重置营销码
    batchUpdateMarketerStatus: post('/marketer/info/admin/batch-update-status'), // 批量更新营销精英状态

    // ============ marketer remote host (远程主机管理) ============
    getRemoteHostList: post('/marketer/remote-host/admin/list'), // 分页查询远程主机列表
    getRemoteHostDetail: post('/marketer/remote-host/admin/detail'), // 获取远程主机详情
    createRemoteHost: post('/marketer/remote-host/admin/create'), // 新增远程主机
    updateRemoteHost: post('/marketer/remote-host/admin/update'), // 修改远程主机
    deleteRemoteHost: post('/marketer/remote-host/admin/delete'), // 删除远程主机
    updateRemoteHostStatus: post('/marketer/remote-host/admin/update-status'), // 修改远程主机状态

    batchAssignMarketer: post('/marketer/remote-host/admin/assign-marketer'), // 批量分配远程主机给营销精英
    batchAssignRemoteHost: post('/marketer/remote-host/admin/batch-assign'), // 批量分配远程主机所属主管
    batchDeleteRemoteHost: post('/marketer/remote-host/admin/batch-delete'), // 批量删除远程主机
    updateRemoteHostSort: post('/marketer/remote-host/admin/update-sort'), // 更新远程主机排序

    // ============ marketer service (客服经理管理) ============
    getMarketerServiceList: post('/marketer/service/admin/list'), // 分页查询客服配置列表
    getMarketerServiceDetail: post('/marketer/service/admin/detail'), // 获取客服配置详情
    createMarketerService: post('/marketer/service/admin/create'), // 新增客服配置
    updateMarketerService: post('/marketer/service/admin/update'), // 修改客服配置
    deleteMarketerService: post('/marketer/service/admin/delete'), // 删除客服配置

    batchAssignMarketerService: post('/marketer/service/admin/batch-assign'), // 批量删除客服配置
    batchDeleteMarketerService: post('/marketer/service/admin/batch-delete'), // 批量删除客服配置
    updateMarketerServiceSort: post('/marketer/service/admin/update-sort'), // 更新客服配置排序
    getMarketerServiceByMarketer: post('/marketer/service/list-by-marketer'), // App端-根据营销精英ID查询客服配置

    // 客户信息管理
    getCustomerList: post('/marketer/customer/admin/list'),                        // 获取客户列表
    getCustomerDetail: post('/marketer/customer/admin/detail'),                    // 获取客户详情
    supplementCustomerInfo: post('/marketer/customer/admin/supplement'),           // 补充客户信息
    reviewCustomer: post('/marketer/customer/admin/review'),                       // 审核客户
    batchReviewCustomer: post('/marketer/customer/admin/batch-review'),            // 批量审核客户
    getCustomerStatistics: post('/marketer/customer/admin/statistics'),            // 获取客户统计
    getCustomerStatsByCountry: post('/marketer/customer/admin/stats-by-country'),  // 按国家分组统计客户数
    searchCustomer: post('/marketer/customer/admin/search'),                       // 全文搜索客户

// 客户额外信息管理
    getCustomerAdditionalInfoList: post('/marketer/customer/additional/admin/list'), // 获取额外信息列表
    addCustomerAdditionalInfo: post('/marketer/customer/additional/admin/add'),    // 添加额外信息
    updateCustomerAdditionalInfo: post('/marketer/customer/additional/admin/update'), // 更新额外信息
    deleteCustomerAdditionalInfo: post('/marketer/customer/additional/admin/delete'), // 删除额外信息

    // ============ marketer user level (营销用户级别奖励配置) ============
    getBossLevel: post('/marketer/user-level/admin/boss/get'),                  // 查询机房老板自身奖励配置
    saveBossLevel: post('/marketer/user-level/admin/boss/save'),                // 保存/更新机房老板奖励配置
    getMarketerLevelsByBoss: post('/marketer/user-level/admin/marketer/list'),  // 查询老板下所有精英的奖励配置列表
    getMarketerLevel: post('/marketer/user-level/admin/marketer/get'),          // 查询单个精英的奖励配置
    saveMarketerLevel: post('/marketer/user-level/admin/marketer/save'),        // 保存/更新精英奖励配置
    deleteMarketerLevel: post('/marketer/user-level/admin/marketer/delete'),    // 删除精英奖励配置

// ============ 用户文件附件相关 API ============
    saveUserFile: post('/user/file/save'), // 保存单个文件关联
    batchSaveUserFiles: post('/user/file/batch-save'), // 批量保存文件关联
    updateUserFile: post('/user/file/update'), // 更新文件信息
    deleteUserFile: post('/user/file/delete'), // 删除文件
    batchDeleteUserFiles: post('/user/file/batch-delete'), // 批量删除文件
    getUserFileList: post('/user/file/list'), // 查询文件列表
    getUserFileListPage: post('/user/file/page'), // 分页查询文件列表
    getUserFileDetail: post('/user/file/detail'), // 查询文件详情
    updateUserDetailRemark: post('/user/detail/update/single'), // 更新用户详情备注
// ==================== 以上内容添加完毕 ====================

    // ============ interest ============
    getALLInterest: post('/interest/all'), // 商户理财产品报表 --wtg
    getInterestDetail: post('/interest/detail'), // 商户理财产品报表 计息明细 --wtg

    // ============ invest ============
    investProjectPrepareList: post('invest/project/prepare/list'),
    investProjectPrepareStatistics: post('invest/project/prepare/statistics'),
    investProjectPrepareDetail: post('invest/project/prepare/detail'),
    investProjectPrepareStatus: post('invest/project/prepare/status'),

    // ============ mec ============
    getUserList: post('/mec/lower/list'), // 商户管理 获取商户信息 --wtg
    // ============ merchant ============
    getLoginUser: post('/merchant/user'), // 手动派单加载会员名称列表

    // ============ movie ============
    findMovie: post('/movie/center/check/movie'), // 电影查找
    addMovie: post('/movie/center/add/single'), // 添加电影
    getMovieType: post('/movie/kind/query/all'), // 获取电影类别
    getMovieList: post('/movie/center/query/page'), // 获取电影列表
    deleMovie: post('/movie/center/delete/single'), // 获取电影列表
    editMovie: post('/movie/center/update/single'), // 编辑电影
    getMovieCount: post('/movie/center/query/count'), // 获取电影数量

    // ============ operate ============
    interfaceLog: post('/operate/log/third/list'), // 如今订单查询-接口日志

    // ============ order ============
    queryListOrderWithdrawDigit: post('/order/withdraw/digit/list'),
    queryOrderWithdrawDigitDetail: post('/order/withdraw/digit/detail'),
    orderWithdrawDigitAudit: post('/order/withdraw/digit/status'),
    withdrawDigitStatistics: post('/order/withdraw/digit/statistics'), // 提现订单统计
    queryOrderRechargeDigitList: post('/order/recharge/digit/list'), // 查询充值记录接口
    changeRechargeDigitStatus: post('/order/recharge/digit/status'), // 数字货币充值审批
    rechargeDigitStatistics: post('/order/recharge/digit/statistics'), // 充值订单统计
    getOrderRechargeDigitDetail: post('/order/recharge/digit/detail'),
    queryOrder: post('/order/queryList'), // 查询订单
    queryOrderStatistics: post('/order/statistics'), // 订单统计(交易订单/待接单)
    tradeOrderPreview: post('/order/build/preview'), // 创建订单预览
    tradeOrderRecharge: post('/order/build/recharge'), // 创建充值订单
    tradeOrderRechargeConfirmPay: post('/order/recharge/confirmPay'), // 充值订单确认支付
    tradeOrderWithdraw: post('/order/build/withdraw'), // 创建提现订单
    tradeOrderDetail: post('/order/detail'),
    tradeOrderRechargeAudit: post('/order/recharge/audit'),
    tradeOrderWithdrawAudit: post('/order/withdraw/audit'),
    queryListOrderRobbing: post('/order/query/robbing'),

    // ============ crypto/transfer - 转账记录管理 ============
    adminGetCryptoTransferList: post('/crypto/transfer/admin/list'),   // 管理端查询转账记录列表
    adminCryptoTransferStatistics: post('/crypto/transfer/admin/statistics'), // 转账记录统计
    adminGetCryptoTransferDetail: post('/crypto/transfer/admin/detail'), // 管理端查询转账记录详情

    // ============ org ============
    saveOrgTeam: post('/org/team/add'),
    updateOrgTeam: post('/org/team/edit'),
    deleteOrgTeam: post('/org/team/delete'),
    updateStatusOrgTeam: post('/org/team/updateStatus'),
    queryDataListOrgTeam: post('/org/team/queryList'),
    saveOrgTeamDepartment: post('/org/team/department/add'),
    updateOrgTeamDepartment: post('/org/team/department/edit'),
    deleteOrgTeamDepartment: post('/org/team/department/delete'),
    updateStatusOrgTeamDepartment: post('/org/team/department/updateStatus'),
    queryDataListOrgTeamDepartment: post('/org/team/department/queryList'),
    saveOrgTeamMember: post('/org/team/member/add'),
    updateOrgTeamMember: post('/org/team/member/edit'),
    deleteOrgTeamMember: post('/org/team/member/delete'),
    queryDataListOrgTeamMember: post('/org/team/member/queryList'),

    // ============ otc ============
    queryOtcRateDetail: post('/otc/detail'), // 查询OTC运营商费率
    queryOtcCountryRateDetail: post('/otc/country/rate/detail'),
    updateOtcCountryRate: post('/otc/country/rate/update'),

    // ============ otcRate ============
    queryUserOtcRateDetail: post('/otcRate/detail'), // 查询用户otc交易费率
// ============ OTC做市商申请管理 (后台管理端) ============
    queryOtcApplicationList: post('/otc/application/list'), // 查询OTC申请列表
    getOtcApplicationDetail: post('/otc/application/detail'), // 获取OTC申请详情
    approveOtcApplication: post('/otc/application/approve'), // 审核通过OTC申请
    rejectOtcApplication: post('/otc/application/reject'), // 拒绝OTC申请
    getOtcApplicationStatistics: post('/otc/application/statistics'), // 获取OTC申请统计

    // ============ OTC商户管理 (后台管理端) ============
    getOtcMerchantList: post('/otc/merchant/list'), // 查询OTC商户列表
    getOtcMerchantDetail: post('/otc/merchant/detail'), // 获取OTC商户详情
    updateOtcMerchantStatus: post('/otc/merchant/update-status'), // 更新商户状态
    updateOtcMerchantProfitRate: post('/otc/merchant/update-profit-rate'), // 更新商户利润分成比例

    // ============ OTC广告管理 (后台管理端) ============
    getOtcAdList: post('/otc/ad/admin/list'), // 查询OTC广告列表
    getOtcAdStatistics: post('/otc/ad/admin/statistics'), // 获取OTC广告统计
    getOtcAdDetailAdmin: post('/otc/ad/detail'), // 获取OTC广告详情
    updateOtcAdStatus: post('/otc/ad/admin/update-status'), // 更新广告状态
    deleteOtcAdAdmin: post('/otc/ad/delete'), // 删除广告

    // ============ OTC订单管理 (后台管理端) ============
    getOtcOrderList: post('/otc/order/admin/list'), // 查询OTC订单列表
    getOtcOrderDetailAdmin: post('/otc/order/detail'), // 获取OTC订单详情
    cancelOtcOrderAdmin: post('/otc/order/cancel'), // 取消订单(管理员操作)
    getOtcOrderStatistics: post('/otc/order/statistics'), // 获取订单统计

    // ============ OTC统计数据 (后台管理端) ============
    getOtcPlatformStats: post('/otc/stats/platform'), // 获取平台OTC统计数据
    getOtcMerchantStats: post('/otc/stats/merchant'), // 获取商户统计数据
    refreshOtcStats: post('/otc/stats/refresh'), // 刷新统计数据
    // ============ pay ============
    userOrderSearch: post('/pay/order/order/list'), // 会员提现订单查询
    getSelectManagerPayOrder: post('/pay/order/selectManagerPayOrder'), // 总公司.商户  入金订单查询
    showUserInfo: post('/pay/order/user/detail'), // 浮窗显示会员的昵称，几级会员，显示上级
    findDetails: post('/pay/order/findOrderById'), // 查看代收订单
    getMentlistDetails: post('/pay/order/findOrderById'), // 查看商户代收订单详情
    getorder: post('/pay/order/changestatus'), // 激活订单
    getPaymentDetail: post('pay/order/find/tofault'), // 新增故障单查询单号
    searchOrder: post('/pay/order/detail/by/orderNo'), // 根据订单id查询冻结
    getHandList: post('/pay/order/manual/order/list'), // 手动派单列表页
    getPayChannel: post('/pay/order/manual/buildOrder'), // 手动派单加载通道资料
    getPayMsg: post('/pay/order/payOrder/detail'), // 手动派单加载支付资料
    getCancel: post('/pay/order/changecancel'), // 手动派单取消
    getPending: post('/pay/order/changestatus'), // 手动派单提交
    getBossReport: post('/pay/order/boss/excel'), // 总公司报表
    getBranchStatisticsReport: post('/pay/order/branch/excel'), // 分公司统计报表
    getFaultDispatch: post('/pay/order/findSystemPayOrder'),
    searchFaultDispatch: post('/pay/order/system/cancle'),
    getAnchorPayOrder: post('/pay/order/selectAnchorPayOrder'), // 主播订单查询

    // ============ personal ============
    getUser: post('/personal/center'), // 个人中心获取个人资料
    subUser: post('/personal/update/center'), // 个人中心提交修改资料

    // ============ platform ============
    findDigital: post('/platform/all'), // 查询数字货币列表
    updateDigital: post('/platform/update/single'), // 修改删除数字货币

    // ============ pledge ============
    pledgeProductDetail: post('pledge/product/detail'),
    pledgeProductRelease: post('pledge/product/release'),
    pledgeProductEdit: post('pledge/product/edit'),
    queryListPledgeRecord: post('pledge/record/queryList'),
    pledgeRecordStatistics: post('pledge/record/statistics'),
    pledgeRecordApprove: post('pledge/record/approve'),

    // ============ dividend ============
    queryDividendHistory: post('/dividend/record/queryList'), // 查询分红记录列表
    queryDividendStatistics: post('/dividend/record/queryStatistics'), // 查询分红统计信息
    getDividendRecordDetail: post('/dividend/record/detail'), // 查询分红记录详情
    triggerQuarterlyDividend: post('/dividend/record/triggerQuarterlyDividend'), // 手动触发季度分红
    triggerYearlySummary: post('/dividend/record/triggerYearlySummary'), // 手动触发年度汇总

    // ============ query ============
    getMechantRate: post('/query/remittance/rate'), // 获取代付手续汇率
    companyMerchantDot: post('/query/count'), // 审核分公司/商户数量
    queryMemberofCity: post('/query/agent/member'), // 查询当前城市的代理会员

    // ============ queryBranch ============
    getBranchCompany: post('/queryBranch'), // 获取现有分公司

    // ============ queryEmployeeById ============
    getSaveInfo: post('/queryEmployeeById/'), // 获取员工详情  --wtg

    // ============ remittance ============
    remitFaultlist: post('/remittance/fault/company/fault'), // 汇款故障单列表
    getRemitFaultNo: post('/remittance/fault/find/tofault'), // 汇款故障单查询金额
    remitFaultInfo: post('/remittance/fault/fault/detail'), // 汇款故障单查看详情
    updateRemitFaultStuts: post('/remittance/fault/deal/fault'), // 处理汇款故障单
    remitFaultPutToFault: post('/remittance/fault/add/single'),
    HKGZD: post('/remittance/fault/query/countmessage'), // 汇款故障单待审批待处理数量

    // ============ resource ============
    getLoginCompany: post('/resource/select/domain/info'), // 登录页--获取登录公司名称
    getCancelReplace: post('/resource/findAll'), // 手动派单获取取消原因
    getChatLogo: post('/resource/select/teamlogo/info'), // 获取logo

    // ============ role ============
    getAllUserList: post('/role/query/all'), // 查询全部角色
    getRoleList: post('/role/admin/query-list'), // 查询角色列表

    // ============ sava ============
    uploadUserPhotos: post('/sava/photo'), // 上传用户头像

    // ============ select ============
    getLoginMer: post('/select/user'), // 手动派单加载商户名称列表

    // ============ statistics ============
    statisticsMemberInfo: post('/statistics/memberInfo'),
    statisticsDigitalTradeInfo: post('/statistics/digitalTradeInfo'),
    statisticsOtcTradeInfo: post('/statistics/otcTradeInfo'),
    statisticsFinancialTradeInfo: post('/statistics/financialTradeInfo'),

    // ============ system ============
    saveNotification: post('/system/announcement/add/single'), // 保存系统公告
    getNotificationList: post('/system/announcement/list'),
    getNotificationStatistics: post('/system/announcement/statistics'), // 公告统计
    delectNotification: post('/system/announcement/delete/single'),
    updateNotification: post('/system/announcement/update/single'),

    // ============ token ============
    onlineReportList: post('/token/system/selectlist'), // 在线统计表
    outSingleRole: post('/token/system/deleteTokenBY'), // 下线单个用户
    outAllRole: post('/token/system/deleteTokenall'), // 下线全部用户
    tokenProjectRelease: post('token/project/release'),
    tokenProjectInfoAndDetailEdit: post('token/project/updateInfoAndDetail'),
    tokenProjectInfoEdit: post('token/project/updateEdit'),
    tokenProjectDelete: post('token/project/delProject'),
    tokenProjectList: post('token/project/list'),
    tokenProjectStatistics: post('token/project/statistics'),
    tokenProjectPrepareDetail: post('token/project/detail'),
    tokenProjectAssignCustomerService: post('token/project/assignCustomerService'),
    tokenProjectPrepareIntroduction: post('token/project/introduction'),
    tokenProjectChangeOnPromotion: post('token/project/promotion'),
    tokenBurn: post('token/burn/save'),
    tokenBurnEdit: post('token/burn/edit'),
    tokenBurnDelete: post('token/burn/del'),
    queryListTokenHolding: post('token/holding/queryList'),
    saveTokenHolding: post('token/holding/establish'),
    updateTokenHolding: post('token/holding/update'),
    queryListTokenHoldingRecord: post('token/holding/record/queryList'),
    saveTokenHoldingRecord: post('token/holding/record/add'),
    updateTokenHoldingRecord: post('token/holding/record/update'),

    // ============ update ============
    getPassgeway: post('/update/user/detail'), // 商户通道信息 ——wtg
    editAnchorCompany: post('/update/anchor'), // 修改主播公司

    // ============ user ============

    addHostBoss: post('/user/admin/add-host-boss'),
    addCustomerManager: post('/user/admin/add-customer-manager'),
    changeUserStatus: post('/user/admin/changeStatus'), // 修改用户状态

    queryEmployeeList: post('/user/admin/query-employee-list'),

    getEmployeeList: post('/query/employee/info'), // 获取员工列表 --wtg
    querySupervisorList: post('/admin/query-supervisor-list'), // 获取主管列表
    queryHostBossList: post('/admin/query-host-boss-list'), // 获取机房老板列表
    queryCustomerManagerList: post('/admin/query-customer-manager-list'),//获取客户经理列表
    queryFinanceDirectorList: post('/admin/query-finance-director-list'),//获取财务主管列表
    queryTechnologyDirectorList: post('/admin/query-technology-director-list'),//获取技术主管列表

    getUserChannel: post('/user/channel/find/channelType'),
    updateUserCustomerServiceStatus: post('/user/update/customerServiceStatus'),
    addAllUsersAsFriends: post('/user/addAllUsersAsFriends'),
    getUserDetailCurrency: post('/user/detail/currency'), // 新增理财获取分公司货币和会员等级
    addCompany: post('/user/company'), // 新增分公司
    getMerFinancialTotal: post('/user/detail/wallet'), // 获取商户理财总额
    getMerAccountBalanceTip: post('/user/detail/account/balance'), // 浮窗商户列表和代理列表根据用户id查余额多币别 --wtg
    getVerificationCode: post('/user/detail/check/phone/email'), // 获取验证码 --wtg
    getUserPhoneOrEmail: post('/user/detail/check/phone/email'), // 获取该账户手机或邮箱验证码
    findChannel: post('/user/channel/find/all/userchannel'), // 提现通道列表
    channelStatus: post('/user/channel/status'), // 通道开关
    channelDetail: post('/user/channel/user/detail'), // 提现通道浮窗查看上级信息
    addBankCard: post('/user/channel/boss/bank/car'), // 银行卡管理获 添加银行卡
    updateBankCard: post('/user/channel/update/bosss/card'), // 银行卡管理获 修改银行卡
    searchMerchantBalance: post('/user/detail/equal/single'), // 查询商户现有余额
    userChannelStatus: post('/user/channel/select/channelConfig'), // 修改会员资料查看会员通道
    updataLangOrTime: post('/user/detail/time/language/prefix'), // 更新时区/语言
    updateUserIpAdd: post('/user/ip/local/update'), // 更新用户ip地址
    setMargin: post('user/detail/profit/margin'), // 設置差額值
    newAnchorNCompany: post('/user/anchor'), // 新增主播/主播公司
    getHigherLiveRate: post('/user/detail/company/liveProfitRate'), // 获取上一级直播收益率
    getGiftRecord: post('/user/live/record/profit/getGift/company'), // 获取礼物消费记录
    checkGiftRecordInfo: post('/user/live/record/profit/getGift/id'), // 集团查看会员礼物消费详情
    getUserVipList: post('/user/selectVIPList'), // 获取汇款错误用户
    getDigitalRate: post('/user/detail/digitCurrencyRate'), // 获取数字货币充值手续费率
    getLivingRoomList: post('/user/live/live/room/management/list'), // 获取直播房间列表
    editLivingRoomInfo: post('/user/live/live/room/management/top'), // 修改直播房间信息
    editLivingRoomViewers: post('/user/live/live/room/management/detail'), // 直播房间管理详情
    groupReport: post('/user/detail/total/interface'), // 集团对账报表
    roleTotal: post('/user/detail/withdrawByUserType'), // 角色提现总额
    roleCurrency: post('/user/detail/withdrawByUserType/currency'), // 角色提现币别明细
    entrustTotal: post('/user/detail/entrustBytype'), // 委托兑换总额
    entrustCurrency: post('/user/detail/entrustByiddetail'), // 委托兑换明细
    remitTotal: post('/user/detail/remintSumDetail'), // 汇款总额
    interestalCurrency: post('/user/detail/interestalldetail'), // 利息支出币别明细
    bonusCurrency: post('/user/detail/bonusDetail'), // 提成币别明细
    vipBalanceCurrency: post('/user/detail/vipbalanceDetail'), // 会员余额明细
    interestallCurrency: post('/user/detail/vipRecordDetail'), // 计息理财总额
    roleReport: post('/user/detail/role/balance/total'), // 角色余额
    financeTotal: post('/user/detail/each/finance/total'), // 会员本币理财、全球理财、幸运理财总额
    financeCurrency: post('/user/detail/each/finance/total/by/currency'), // 会员本币理财、全球理财、幸运理财各个币别总额
    incomeTotal: post('/user/detail/income/total'), // 商户/直播、数字货币充值总额
    payOrderCurrency: post('/user/detail/pay/order/total/by/currency'), // 商户/主播派单各个币别总额
    payDigitCurrency: post('/user/detail/merchant/digit/income/total/by/currency'), // 商户/主播数字货币充值各个数字货币总额
    digitTotal: post('/user/detail/flow/buy/digit/amount/by/digit'), // 流量购入总额
    commissionTotal: post('/user/detail/income/commission/total'), // 商户/主播派单、数值货币充值手续费总额
    commissionCurrency: post('/user/detail/commission/by/currency'), // 派单payOrder（主播liveAnchor和商户merchant）、数值货币digit（主播和商户）、法定货币legal、汇款remittance、集团直播收益giftProfit手续费各个币别总额
    entrustCommissionCurrency: post('/user/detail/entrust/commission/by/currency'), // 委托兑换手续费各个币别总额
    roleBalanceDetail: post('/user/detail/role/balance/detail'), // 商户余额、分公司余额、总公司余额、商代余额
    roleUserId: post('/user/detail/by/user/id'), // 根据用户id显示多币别余额

    // ============ video ============
    getShortVideoList: post('/video/adminselecttvideo'), // 获取视频列表
    editShortVideoInfo: post('/video/adminupdateVideo'), // 修改短视频资料 // 置顶/取消置顶 //删除

    // ============ vip ============
    postUserInfo: post('/vip/edit/user'), // 会员修改资料
    updateUserVipStatus: post('/vip/changeVipStatus'),
    editUserManage: post('/vip/edit/user'), // 修改会员资料
    editCompanyManage: post('/vip/operate/user'), // 审核分公司资料
    memberUpgradeList: post('/vip/upgrade/list'), // 会员升级列表
    queryListVipUpgrade: post('/vip/upgrade/queryList'),
    queryListUser: post('/user/queryList'), // 获取会员列表
    reviewUser: post('/vip/upgrade/update/status'), // 审核会员


    // ============ 特殊处理的方法 ============
    //http://192.168.2.77:1088/api/main/bank/bank/detail
    //http://192.168.2.77:2088/api/file/verification/img?Authorization=7c228dfdd5f5463987e1dcf624e2d926
    // 文件服务接口都要 per-request 覆盖 Service.baseURL（默认是 /api/main），
    // 否则 dev 环境会被拼成 /api/main/api/file/xxx 而 404。
    // 调用方传入的 baseurl（通常是 config.getImgBase()）作为 axios 的 baseURL。
    //上传用户截取的头像到服务器以获取头像URL
    getUserAvatarURL(baseurl, autorization, params) {
        return Service.post("/file/upload" + autorization, params, {baseURL: baseurl});
    },

    //上传图片验证是否是二维码
    upCodeImg(baseurl, autorization, params) {
        return Service.post("/verification/img" + autorization, params, {baseURL: baseurl});
    },

    //上传图片
    uploadImg(baseurl, params) {
        return Service.post("/file/upload", params, {baseURL: baseurl});
    },

    uploadFile(file) {
        let formData = new FormData()
        formData.append('file', file)
        return Service.post("/file/upload", formData, {baseURL: config.getImgBase()});
    },

    //催单
    getsms(id) {
        return Service.get('/common/send/hurry/' + id);
    },

    uploadChannelIcon(params) {
        return Service.post('/img/channel/upload', params, {baseURL: config.getImgBase()});
    },

    sortOrgTeam(params) {
        // 团队：整体列表内上/下移动一位
        return Service.post('/org/team/sort', params)
    },

    sortOrgTeamDepartment(params) {
        // 部门：同一团队内部排序
        return Service.post('/org/team/department/sort', params)
    },

    sortOrgTeamMember(params) {
        // 成员：同一部门内部排序
        return Service.post('/org/team/member/sort', params)
    },
    // ============ customer manager application (客户经理注册申请) ============
    sendCustomerManagerEmailCode: post("/customer-manager/application/send-email-code"), // 发送邮箱验证码
    submitCustomerManagerApplication: post("/customer-manager/application/submit"), // 提交注册申请
    getCustomerManagerApplicationList: post("/customer-manager/application/admin/list"), // 查询申请列表
    reviewCustomerManagerApplication: post("/customer-manager/application/admin/review"), // 审批申请
    deleteCustomerManagerApplication: post('/customer-manager/application/delete/single'),

    // ============ 系统配置中心 t_sys_config ============
    // 列出全部 ACTIVE 配置（GET 因后端 @GetMapping）
    sysConfigList: () => Service.get('/sys-config/list'),
    // 按 module 分组返回，前端按 module 渲染分组表单
    sysConfigGroup: () => Service.get('/sys-config/group'),
    // 更新单个配置 {key, value}
    sysConfigUpdate: post('/sys-config/update'),
    // 仅 sysadmin：拉取模块可见性映射 {module: sysadminOnly}
    sysConfigModuleMeta: () => Service.get('/sys-config/module-meta'),
    // 仅 sysadmin：切换某模块「仅 sysadmin 可见」 {module, sysadminOnly}
    sysConfigToggleModuleVisibility: post('/sys-config/module/toggle-visibility'),

    // ============ 运维管理-App管理 (V4.2.4) ============
    opsAppOverview: post('/ops/app/overview'),                 // 当前 WGT/APK 概况
    opsAppPkgPage: post('/ops/app/pkg/page'),                  // 包历史分页 {appKey?,packageType?,page,size}
    opsAppPkgPrecheck: post('/ops/app/pkg/precheck'),        // 上传后预检(MD5判重) {packageType,fileUrl}
    opsAppPkgCommit: post('/ops/app/pkg/commit'),             // 提交包 {packageType,fileUrl,fileName?,versionCode?,md5?,fileSize?}
    opsAppPkgEdit: post('/ops/app/pkg/edit'),                 // 编辑包 {id,versionName?,releaseNotes?,remark?}
    opsAppPkgSetCurrent: post('/ops/app/pkg/set-current'),    // {id}
    opsAppPkgRollback: post('/ops/app/pkg/rollback'),         // {id}
    opsAppPkgToggle: post('/ops/app/pkg/toggle'),             // {id, disable}
    opsAppPkgDelete: post('/ops/app/pkg/delete'),             // 软删除包 {id}
    opsAppBlacklistPage: post('/ops/app/blacklist/page'),     // 黑名单用户分页 {keyword?,onlyBlacklisted?,page,size}
    opsAppBlacklistToggle: post('/ops/app/blacklist/toggle'), // 拉黑/取消 {userName,black}
    // 运维管理-官网管理（App下载 / 社媒）
    opsSiteList: post('/site/item/admin/list'),               // {category}
    opsSiteSave: post('/site/item/admin/save'),               // {id?,category,itemKey,...}
    opsSiteSetStatus: post('/site/item/admin/set-status'),    // {id, status: online|coming|hidden}
    opsSiteSetFeatured: post('/site/item/admin/set-featured'),// {id, featured}
    opsSiteMove: post('/site/item/admin/move'),               // {id, direction: up|down}
    opsSiteDelete: post('/site/item/admin/delete'),           // {id}
    // 运维管理-定时任务管理
    opsTaskList: post('/ops/task/list'),                      // 列出所有定时任务
    opsTaskRun: post('/ops/task/run'),                        // 手动执行 {key}
    // 互动矩阵营销-设备租赁
    rentalPricingList: post('/marketer/rental/pricing/list'), // 全部定价
    rentalPricingSave: post('/marketer/rental/pricing/save'), // 保存一条定价 {id?,periodUnit,rentalFee,hostingFee,enabled,discountRate?,discountLabel?,sort?}
    rentalOrderPage:   post('/marketer/rental/order/page'),   // 订单分页 {status?,orderType?,keyword?,page,size}
    rentalOrderApprove:post('/marketer/rental/order/approve'),// 通过 {id,comment?}
    rentalOrderReject: post('/marketer/rental/order/reject'), // 驳回 {id,comment?}
    rentalOrderSetEnd: post('/marketer/rental/order/set-end'),// 改到期 {id,endDate}
    rentalOrderExtend: post('/marketer/rental/order/extend'), // 快捷续期 {id,unit,amount}
    rentalOrderStats:  () => Service.get('/marketer/rental/order/stats'), // 顶部统计条：待审核/已通过/已驳回/已取消/总数

    // ============ 我的钱包 ============
    myWalletSummary: post('/my-wallet/summary'),
    myWalletFlow:    post('/my-wallet/flow'),
    myUserFlow:      post('/my-wallet/user-flow'), // 管理层查指定用户资金流水
    // 创建充提订单（复用现有接口）
    createRechargeDigitOrder: post('/order/recharge/digit/save'),
    createWithdrawDigitOrder: post('/order/withdraw/digit/withdraw'),
    // 我的充值/提现历史
    myDigitRechargeList: post('/order/recharge/digit/list'),
    myDigitWithdrawList: post('/order/withdraw/digit/list'),
    // 平台收款配置（按币种返回网络 + 钱包地址 + 二维码）
    walletQueryBank: post('/bank/queryList'),

    // ============ 模特管理 ============
    modelAdminList:   post('/model/admin/list'),
    modelAdminSave:   post('/model/admin/save'),
    modelAdminStatus: post('/model/admin/status'),
    modelAdminRemove: post('/model/admin/remove'),
    modelDetail:      post('/model/detail'),
    modelPlazaList:   post('/model/plaza/list'),

    // ============ 引粉订单 ============
    fanOrderCreate:      post('/fan-order/create'),
    fanOrderDetail:      post('/fan-order/detail'),
    fanOrderMyManager:   post('/fan-order/my/manager'),
    fanOrderMyManagerStats: post('/fan-order/my/manager/stats'),   // V4.2.0: 引粉订单顶部统计（今日+累计）
    fanOrderMyMarketer:  post('/fan-order/my/marketer'),
    fanOrderConfirm:     post('/fan-order/confirm'),
    fanOrderRefund:      post('/fan-order/refund'),         // 统一退订：后端按状态分流(接单前直接退订/接单后申请审核)
    fanOrderRefundAgree: post('/fan-order/refund/agree'),   // V4.2.3 营销精英同意退订
    fanOrderRefundReject:post('/fan-order/refund/reject'),  // V4.2.3 营销精英拒绝退订

    // ============ V4.2.3 项目文档（互动矩阵营销-项目文档管理 / 个人中心-项目文档） ============
    marketingProjectList:          post('/marketing-project/list'),
    marketingProjectSave:          post('/marketing-project/save'),
    marketingProjectDelete:        post('/marketing-project/delete'),
    marketingProjectFileList:      post('/marketing-project/file/list'),
    marketingProjectFileBatchSave: post('/marketing-project/file/batch-save'),
    marketingProjectFileDelete:    post('/marketing-project/file/delete'),

    // ============ 申报客户审批升级 ============
    fanReviewList:      post('/fan-customer-review/list'),
    fanReviewConfirmWA: post('/fan-customer-review/confirm-whatsapp'),
    fanReviewApprove:   post('/fan-customer-review/approve'),
    fanReviewReject:    post('/fan-customer-review/reject'),
    fanReviewListProof: post('/fan-customer-review/reject-proofs'),

    // ============ V4.1.1 异常号待人工修复 ============
    customerManualFixList: post('/fan-customer-review/manual-fix/list'),
    customerManualFixSave: post('/fan-customer-review/manual-fix/save'),
    customerManualFixMoveToDraft: post('/fan-customer-review/manual-fix/move-to-draft'),
};